// extracted by mini-css-extract-plugin
module.exports = {"Title":"DangerZone_Title__1bIjx","OptionBody":"DangerZone_OptionBody__utd3k"};